import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";

@Directive({
    selector: '[inView]',
    standalone: true
  })
  export class InViewDirective implements OnInit, OnDestroy {
    @Output() inView = new EventEmitter<boolean>();
    private observer: IntersectionObserver | undefined;
  
    constructor(private element: ElementRef) {}
  
    ngOnInit() {
      const options = {
        threshold: 0.5
      };
  
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          this.inView.emit(entry.isIntersecting);
        });
      }, options);
  
      if (this.element.nativeElement) {
        this.observer.observe(this.element.nativeElement);
      }
    }
  
    ngOnDestroy() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }